






import Vue from 'vue';
import { mapState } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import { ConfigVersion } from '@/api/configversion/';

@Component({
  computed: mapState([
    'fiId', 'configVersion',
  ]),
})
export default class LegacyRedirect extends Vue {
	@Prop() destination!:string;

	fiId!:string;

	configVersion!:ConfigVersion;

	mounted() {
	  let url: string = 'https://krp-config.';

	  if (window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('.dev.') !== -1) {
	    url += 'dev.';
	  } else if (window.location.href.indexOf('.uat.') !== -1) {
	    url += 'uat.';
	  }

	  url += 'kasasaonline.com/#/rewards-config/';

	  if (this.fiId) {
		 	url += `${this.fiId}/`;

	    if (this.destination) {
	      url += this.destination;
	    }

	    if (this.configVersion) {
	      url += `?version=${this.configVersion.id}`;
	    }
	  }
	  window.location.replace(url);
	}
}
